<script setup lang="ts">
import { RouterLink } from 'vue-router';
import ApiResponsiveImage from '@/components/ApiResponsiveImage.vue';
import { type SiteLogo, isOptimisedSiteLogo } from '@/navTree';
import { onOfflineMediaImgError } from '@/utils/offlineMediaPlaceholder';

defineProps<{
  rootUrl: string;
  siteName: string;
  siteSubtitle: string;
  siteLogos: SiteLogo[];
  /** Extra classes on the root link (e.g. --in-top-bar, --probe). */
  linkClass?: string;
}>();

defineEmits<{
  click: [];
}>();
</script>

<template>
  <RouterLink
    :to="rootUrl"
    class="side-nav__desktop-brand"
    :class="linkClass"
    @click="$emit('click')"
  >
    <div v-if="siteLogos.length" class="side-nav__logo-list side-nav__logo-list--desktop">
      <template v-for="logo in siteLogos" :key="logo.id">
        <ApiResponsiveImage
          v-if="isOptimisedSiteLogo(logo)"
          :image="logo"
          alt=""
          class="side-nav__desktop-logo side-nav__desktop-logo--optimised"
          sizes="64px"
          loading="lazy"
        />
        <img
          v-else
          :src="logo.url"
          alt=""
          class="side-nav__desktop-logo"
          :width="logo.width"
          :height="logo.height"
          loading="lazy"
          @error="onOfflineMediaImgError"
        >
      </template>
    </div>
    <img
      v-else
      src="/INDMO.png"
      alt=""
      class="side-nav__desktop-logo"
      width="64"
      height="64"
      @error="onOfflineMediaImgError"
    >
    <div class="side-nav__desktop-brand-text">
      <span class="side-nav__desktop-title">{{ siteName }}</span>
      <span v-if="siteSubtitle" class="side-nav__desktop-subtitle">{{ siteSubtitle }}</span>
    </div>
  </RouterLink>
</template>
